import BeraterController from './BeraterController';
import NeoBeraterTargetDialogController from './target/NeoBeraterTargetDialogController';


angular
  .module( 'VSPApp' )
  .controller( 'BeraterController', BeraterController )
  .controller( 'NeoBeraterTargetDialogController', NeoBeraterTargetDialogController );
